import { BridgeConfig } from '../model/bridge-config';
import BaseBridge from '../base-bridge';

export default class Bridge extends BaseBridge {
  iframe: HTMLIFrameElement;

  constructor(iframe: HTMLIFrameElement, config: BridgeConfig) {
    super(config);
    this.iframe = iframe;
    const { onReceiveMessage } = this;
    this.onReceiveMessage = (event) => {
      if (event.source === iframe.contentWindow) {
        onReceiveMessage(event);
      }
    };
    window.addEventListener('message', this.onReceiveMessage);
  }

  sendJsonMessage(message: Record<string, any>): void {
    this.iframe.contentWindow?.postMessage(message, this.config.origin);
  }

  dispose(): void {
    window.removeEventListener('message', this.onReceiveMessage);
  }
}
